import React from 'react'

const CATEGORIAS_ACCESORIOS = ["Fundas / Covers", "Vidrios Templados", "Cargadores / Bloques", "Cables", "Auriculares", "Otros"]

export default function ModalAccesorio({ formAccesorio, setFormAccesorio, guardar, setModal, editId }) {
  return (
    <div className="inv-modal-overlay">
      <div className="inv-modal-box">
        <div className="inv-modal-header">
          <h2 className="inv-modal-title">
            {editId ? 'Actualizar Accesorio' : 'Nuevo Accesorio'}
          </h2>
          <button onClick={() => setModal(false)} className="inv-modal-close">✕</button>
        </div>
        
        <form onSubmit={guardar} className="inv-modal-form">
          <div className="inv-form-grid animate-fade-in">
            <div className="span-2">
              <label className="inv-modal-label">Categoría del Accesorio *</label>
              <select required value={formAccesorio.categoria} onChange={e => setFormAccesorio({ ...formAccesorio, categoria: e.target.value })} className="inv-modal-select">
                <option value="">Seleccionar categoría...</option>
                {CATEGORIAS_ACCESORIOS.map(cat => <option key={cat} value={cat}>{cat}</option>)}
              </select>
            </div>
            <div className="span-2">
              <label className="inv-modal-label">Nombre del Producto / Descripción *</label>
              <input required value={formAccesorio.nombre} onChange={e => setFormAccesorio({ ...formAccesorio, nombre: e.target.value })} placeholder="Ej: Funda Silicone Case con MagSafe" className="inv-modal-input" />
            </div>
            <div className="span-2">
              <label className="inv-modal-label">Modelos de Celulares Compatibles *</label>
              <input required value={formAccesorio.compatibilidad} onChange={e => setFormAccesorio({ ...formAccesorio, compatibilidad: e.target.value })} placeholder="Ej: iPhone 13, iPhone 14 (o 'Universal')" className="inv-modal-input" />
              <p className="config-help-text" style={{ fontSize: '11px', color: '#64748b', marginTop: '4px' }}>Crucial: El bot usará este campo para saber si ofrecer este accesorio al cliente.</p>
            </div>
            <div>
              <label className="inv-modal-label">Precio al Público *</label>
              <div className="price-input-group">
                <select value={formAccesorio.moneda} onChange={e => setFormAccesorio({ ...formAccesorio, moneda: e.target.value })} className="inv-modal-select price-currency-select">
                  <option value="USD">US$</option>
                  <option value="ARS">ARS$</option>
                </select>
                <input required type="text" value={formAccesorio.precioInput} onChange={e => {
                  const raw = e.target.value.replace(/\D/g, '');
                  setFormAccesorio({ ...formAccesorio, precioInput: raw ? Number(raw).toLocaleString('es-AR') : '' });
                }} placeholder="0" className="inv-modal-input price-amount-input" />
              </div>
            </div>
            <div>
              <label className="inv-modal-label">Cantidad en Stock (Unidades) *</label>
              <input required type="number" min="0" value={formAccesorio.stock} onChange={e => setFormAccesorio({ ...formAccesorio, stock: e.target.value })} placeholder="Ej: 10" className="inv-modal-input" />
            </div>
          </div>

          <div className="inv-modal-actions">
            <button type="button" onClick={() => setModal(false)} className="btn-inv-secondary">Cancelar</button>
            <button type="submit" className="btn-inv-submit">Guardar Cambios</button>
          </div>
        </form>
      </div>
    </div>
  )
}